<template>
  <div>
    <div id="top">
      <div id="header">
        <img src="@/assets/logo.png" alt="">
        <div id="routes">
          <router-link id="first" @mouseover.native="preview(0)" @mouseleave.native="resetPreview" to="/">Home</router-link>
          <router-link @mouseover.native="preview(1)" @mouseleave.native="resetPreview" to="/work">Work</router-link>
          <router-link @mouseover.native="preview(2)" @mouseleave.native="resetPreview" to="/projects">Projects</router-link>
          <router-link @mouseover.native="preview(3)" @mouseleave.native="resetPreview" to="/school">School</router-link>
          <router-link @mouseover.native="preview(4)" @mouseleave.native="resetPreview" @click.native.stop to="/blog">Blog</router-link>
        </div>
      </div>
      <div id="contact">
        <FacebookIcon :link="Facebook" :darkMode="false"/>
        <LinkedInIcon :link="LinkedIn" :darkMode="false"/>
        <InstagramIcon :link="Instagram" :darkMode="false"/>
        <EmailIcon :darkMode="false"/>
      </div>
    </div>
    <div id="parallax">
      <div id="coloring"></div>
    </div>
    <div id="preload">
      <img src="../assets/backgrounds/home.jpg" />
      <img src="../assets/backgrounds/work.jpeg" />
      <img src="../assets/backgrounds/projects.jpg" />
      <img src="../assets/backgrounds/school.jpeg" />
      <img src="../assets/backgrounds/blog.jpg" />
    </div>
    <div id="titleContainer">
      <h1 id="title">{{ (this.current == 0) ? "Dylan Cauwels" : this.title.name }}</h1>
      <div v-if="this.current == 0" id="icons">
        <GithubIcon :link="Github" :darkMode="false"/>
        <EtsyIcon :link="Etsy" :darkMode="false"/>
        <StackOverflowIcon :darkMode="false"/>
      </div>
    </div>
    <HomeTitle v-if="this.current == 0"/>
    <Title v-else-if="this.current != 4" :quote="quote" :author="author" :color="this.headerData[this.current != -1 ? this.current : 0].borderColor"/>
    <BlogTitle v-else/>
  </div>
</template>

<script>
import store from '@/store'
import Title from './Title.vue'
import HomeTitle from './HomeTitle.vue'
import BlogTitle from './BlogTitle.vue'

import GithubIcon from './icons/Github.vue'
import EtsyIcon from './icons/Etsy.vue'
import LinkedInIcon from './icons/LinkedIn.vue'
import InstagramIcon from './icons/Instagram.vue'
import StackOverflowIcon from './icons/StackOverflow.vue'
import FacebookIcon from './icons/Facebook.vue'
import EmailIcon from './icons/Email.vue'
/**
 * TODO
 * grey out titles a bit on preview mode
 * fix issue of background image always becoming home image on load
 * load background images with the header module immediately
 */
export default {
  components: {
    Title,
    HomeTitle,
    BlogTitle,
    GithubIcon,
    EtsyIcon,
    LinkedInIcon,
    InstagramIcon,
    StackOverflowIcon,
    FacebookIcon,
    EmailIcon,
  },
  data: function () {
    return {
      current: -1,
      headerData: store.options,
      title: {},
      quote: "",
      author: "",
      mapping: [],
      images: [],
      LinkedIn: "https://www.linkedin.com/in/DylanCauwels",
      Etsy: "https://www.etsy.com/shop/DataDrivenDesigns?ref=simple-shop-header-name",
      Github: "https://www.github.com/DylanCauwels",
      Instagram: "https://www.instagram.com/dylan.cauwels",
      Facebook: "https://www.facebook.com/people/Dylan-Cauwels/100006885246706"
    }
  },
  created() {
    store.options.forEach(element => {
      this.mapping.push(element.slug);
    })
    store.options.forEach(element => {
      this.images.push(new Image());
      console.log("url(" + require('@/assets/backgrounds/' + element.image) + ")");
      this.images[this.images.length - 1].src = "url(" + require('@/assets/backgrounds/' + element.image) + ")";
    })
  },
  mounted() {
    this.setMapping();
    this.setHeader();
    this.setQuoteAndTitle();
    this.moveTitle();
    document.getElementById("parallax").style.backgroundImage = this.images[this.current].getAttribute("src"); //"url(" + require('@/assets/backgrounds/' + this.headerData[this.current].image) + ")";
    document.getElementById("coloring").style.visibility = "hidden";
  }, 
  watch:{
    // can add to, from variables to track routing jumps
    $route (){
        this.setMapping();
        if (this.current < 0) this.current = 0;
        this.resetPreview();
        this.setHeader();
        this.setQuoteAndTitle();
        document.getElementById("coloring").style.visibility = "hidden";
        document.getElementById("title").classList.remove("transition");
        this.moveTitle();
        document.getElementById("title").classList.add("fadeIn");
        document.getElementById("title").style.opacity = "1";
        // document.getElementById("parallax").style.backgroundImage = "url(" + require('@/assets/backgrounds/' + this.headerData[this.current].image) + ")";
    }
  },
  methods: {
    setMapping: function () {
      var route = this.$route.path;
      var base = route.split('/')
      // get base URL and map to the proper header
      this.current = this.mapping.indexOf(base[1]);
    },
    preview: function (div) {
      // check if we're on the page the hover is on and thus don't need to preview
      if(div !== this.current) {
        document.getElementById("parallax").style.backgroundImage = this.images[div].getAttribute("src"); //"url(" + require('@/assets/backgrounds/' + this.headerData[div].image) + ")";
        document.getElementById("coloring").style.visibility = "visible";
        this.title = this.headerData[div].title;
        document.getElementById("title").style.borderColor = this.headerData[div].borderColor;

        if (document.getElementById("title").classList.contains("fadeIn")) {
          document.getElementById("title").classList.remove("fadeIn");
          document.getElementById("title").classList.add("transition");
        }
        document.getElementById("title").style.opacity = ".5";
      }
    },
    resetPreview: function() {
      document.getElementById("parallax").style.backgroundImage = this.images[this.current].getAttribute("src"); //"url(" + require('@/assets/backgrounds/' + this.headerData[this.current].image) + ")";
      document.getElementById("coloring").style.visibility = "hidden";
      this.title = this.headerData[this.current].title;
      document.getElementById("title").style.borderColor = this.headerData[this.current].borderColor;
      document.getElementById("title").style.opacity = "1";
    },
    setHeader: function () {
      var c = document.getElementById("routes").childNodes;
      for(var i = 0; i < c.length; i++) {
        if (i === this.current) {
          c[i].style.fontWeight = "bolder";
        } else {
          c[i].style.fontWeight = "inherit";
        }
      }
    },
    setQuoteAndTitle: function () {
      this.title = this.headerData[this.current].title;
      this.quote = this.headerData[this.current].quote;
      this.author = this.headerData[this.current].author;
    },
    moveTitle: function () {
      var container = document.getElementById("titleContainer");
      var title = document.getElementById("title");
      container.style.display = "none";
      container.style.left = this.title.left;
      container.style.top = this.title.top;
      title.style.fontSize = this.title.fontSize;
      title.style.fontWeight = this.current == 0 ? "200" : "900";
      title.style.color = this.title.color;
      container.style.display="block"
    }
  },
}
</script>

<style scoped>
  #preload {
    display: none;
  }
  #icons {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      margin-left: 4.5vw;
  }
  #titleContainer {
      position: absolute;
      font-size: 12rem;
      opacity: 1;
  }
  .fadeIn {
    animation: fadein 2s;
    -moz-animation: fadein 3s; 
    -webkit-animation: fadein 3s; 
    -o-animation: fadein 3s;
  }
  .fadeHalf {
    animation: fadehalf 2s;
  }
  .transition {
    transition: opacity .5s linear;
  }
  #top {
    padding: 10px;
    position: absolute;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0));
    width: 100%;
    display: flex;
    flex-direction: row;
    height: min-content;
    align-items: center;
    padding-left: 15px;
  }
  #header {
    display: flex;
    align-items: center;
    float: left;
    overflow-x: auto;
  }
  #routes {
    display: flex;
    flex-direction: row;
    height: min-content;
    align-items: center;
    padding-left: 15px;
  }
  #contact {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  #first {
    border-width: 0px;
  }
  #parallax {
    height: 85vh;
    background-attachment: fixed;
    background-position: left top;
    background-repeat: no-repeat;
    background-size: 100vw 85vh;
    transition: background 0.4s linear 0.1s;
  }
  #coloring {
    background-image: radial-gradient(circle farthest-corner at center, rgba(0, 0, 0, .4), rgba(0, 0, 0, .8));
    height: 100%;
    width: 100%;
  }
  img {
    width: 35px;
    height: 35px;
  }
  a {
    color: white;
    border-left: 1px solid white;
    font-size: 18px;
    width: 6vw;
    min-width: 80px;
    text-align: center;
    margin-bottom: 0px;
  }
  a:hover {
    font-weight: bolder;
    cursor: pointer;
    color: #D69400;
    text-decoration: none;
  }
  #icons > * {
    margin-left: 15px;
  }
  @keyframes fadehalf {
    from {
        opacity:1;
    }
    to {
        opacity:.5;
    }
  }
  @keyframes fadein {
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
  }
  @-moz-keyframes fadein { /* Firefox */
      from {
          opacity:0;
      }
      to {
          opacity:1;
      }
  }
  @-webkit-keyframes fadein { /* Safari and Chrome */
      from {
          opacity:0;
      }
      to {
          opacity:1;
      }
  }
  @-o-keyframes fadein { /* Opera */
      from {
          opacity:0;
      }
      to {
          opacity: 1;
      }
  }
</style>